AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
CheckItemMenuView = require 'app/scripts/views/checklist/check-item-menu-view'
Dates = require 'app/scripts/lib/dates'
{ dontUpsell } = require '@trello/config'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
EditableView = require 'app/scripts/views/internal/editable-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ forNamespace } = require 'app/common/lib/util/i18n'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
moment = require 'moment'
{ OrganizationFeature } = require '@trello/product-features'
PopOver = require 'app/scripts/views/lib/pop-over'
TFM = require 'app/scripts/lib/markdown/tfm'
Util = require 'app/scripts/lib/util'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
{ track, trackUe, Verb, Noun } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('checklist_item')
{ toggleAssignPopover, replaceAssignInputValue } = require 'app/scripts/views/checklist/toggle-assign-popover'
{ toggleDatePopover, replaceDueInputValue } = require 'app/scripts/views/checklist/toggle-date-popover'
{ toggleUpsellAdvancedChecklist } = require 'app/scripts/views/checklist/upsell-advanced-checklist'
urls = require 'app/scripts/controller/urls'
memberAvatarTemplate = require 'app/scripts/views/templates/member_avatar'
{ avatarDomain } = require '@trello/config'
Layout = require 'app/scripts/views/lib/layout'
{ getAssignee, getDueDate, trackNameChange, trackNameRender } = require './check-item-name'
{ hasAdvancedChecklists, hasUpsell } = require './has-advanced-checklists'

viewTitle = forNamespace('view title')

template = t.renderable ({ canAssign, canSetDueDate, editable, upsellEnabled }) ->
  t.div '.checklist-item-checkbox', { class: t.classify({ enabled: editable, 'js-toggle-checklist-item': editable }) }, ->
    t.icon 'check', { class: 'checklist-item-checkbox-check' }

  t.div '.checklist-item-details.non-empty.js-checkitem', { class: t.classify({ editable }), attr: 'name' }, ->
    t.div '.checklist-item-row.js-checkitem-row.current', ->
      t.span '.checklist-item-assignee.js-checklist-item-assignee.hide-on-edit'
      t.span '.checklist-item-text-and-due.hide-on-edit', ->
        t.span '.checklist-item-details-text.markeddown.js-checkitem-name'
        t.span '.checklist-item-due.js-checklist-item-due'
      if editable
        t.div '.edit.options-menu', { class: t.classify({ assign: (canAssign || upsellEnabled), due: canSetDueDate || upsellEnabled }) }, ->
          t.textarea '.field.full.single-line.js-checkitem-input', { type: 'text' }

    if editable
      t.p '.edits-warning.quiet', ->
        t.format 'you-have-unsaved-edits-on-this-field'
        t.text ' '
        t.a '.js-view-edits', { href: '#' }, ->
          t.format 'view-edits'
        t.text " - "
        t.a '.js-discard-edits', { href: '#' }, ->
          t.format 'discard'

    if editable
      t.div '.checklist-item-menu-wrapper.hide-on-edit', ->
        t.div '.checklist-item-menu.js-open-menu', ->
          t.span '.icon-sm.icon-overflow-menu-horizontal'

assigneeTemplate = t.renderable ({ member }) ->
  if member
    t.button '.subtle.js-open-assign-selector-no-edit', ->
      t.div '.member.m-member-mod-24', ->
        memberAvatarTemplate(member)

dueTemplate = t.renderable (due, className) ->
  if due
    t.button '.subtle.js-open-due-selector-no-edit', { class: className }, ->
      t.icon 'clock'
      if due
        t.text due

module.exports = mixin AutoInsertionView, CompleterUtil, class CheckItemView extends EditableView
  className: 'checklist-item'

  allowNewlines: false

  initialize: ->
    @listenTo @model,
      'change:name': ->
        @renderName()
        @renderAssignee()
        @renderDue()
      'change:state': ->
        @renderState()
        @renderDue()
    super

  events:
    'keyup .js-checkitem-input': 'keyAutoMention'
    'click .js-toggle-checklist-item': 'toggleState'

    'click .js-open-menu': 'openMenu'

    'click .js-open-mention-selector': 'commentMentionMember'
    'click .js-open-emoji-selector': 'commentAddEmoji'
    'movecheckitem': 'moveCheckItem'

    # Advanced Checklists
    'click .js-open-assign-selector': (e) ->
      @assignUpsellOrPopover(e, {
        setValue: (value) => replaceAssignInputValue(@el.querySelector('.js-checkitem-input'), value)
        getInitialValue: => @el.querySelector('.js-checkitem-input').value
        trackingMethod: 'by clicking member button in edit checkitem view'
      })

    'click .js-open-assign-selector-no-edit': (e) ->
      @assignUpsellOrPopover(e, {
        setValue: (name) => @_setName(name, 'by clicking member in assign member popover')
        getInitialValue: => @model.get('name')
        trackingMethod: 'by clicking member button in checkitem view'
      })

    'click .js-open-due-selector': (e) ->
      @dueDateUpsellOrPopover(e, {
        setValue: (value) => replaceDueInputValue(@el.querySelector('.js-checkitem-input'), value)
        getInitialValue: => @el.querySelector('.js-checkitem-input').value
        trackingMethod: 'by clicking due date button in edit checkitem view'
      })

    'click .js-open-due-selector-no-edit': (e) ->
      @dueDateUpsellOrPopover(e, {
        setValue: (name) => @_setName(name, 'by clicking a submit button in due date picker')
        getInitialValue: => @model.get('name')
        trackingMethod: 'by clicking due date badge in checkitem view'
      })

  dueDateUpsellOrPopover: (e, { setValue, getInitialValue, trackingMethod, billingUrl }) ->
    if hasAdvancedChecklists(@model.getBoard())
      toggleDatePopover({
        title: viewTitle('change due date') + ' (Beta)',
        setValue,
        getInitialValue,
        trackingMethod,
      })(e)
    else toggleUpsellAdvancedChecklist({
      trackingMethod: 'by clicking due date button in checkitem composer',
      billingUrl: @getBillingUrl()
    })(e)

  assignUpsellOrPopover: (e, { setValue, getInitialValue, trackingMethod }) ->
    if hasAdvancedChecklists(@model.getBoard())
      toggleAssignPopover({
        setValue
        getInitialValue
        title: viewTitle('assign') + ' (Beta)'
        getCardMembers: => @model.getCard().memberList.toJSON()
        getBoardMembers: => @model.getBoard().memberList.filterDeactivated(force: true).toJSON()
        trackingMethod
      })(e)
    else toggleUpsellAdvancedChecklist({
      trackingMethod: 'by clicking member button in checkitem composer',
      billingUrl: @getBillingUrl()
    })(e)

  getCard: -> @model.getCard()

  getBillingUrl: ->
    org = @model.getBoard().getOrganization()
    if org?
      urls.getOrganizationBillingUrl(org)

  render: ->
    view = @
    model = @model

    editable = @model.editable()
    _hasAdvancedChecklists = hasAdvancedChecklists(@model.getBoard())
    _hasUpsell = hasUpsell()


    @$el.html(
      template({
        canAssign: editable && _hasAdvancedChecklists
        canSetDueDate: editable && _hasAdvancedChecklists
        upsellEnabled: editable && _hasUpsell && !_hasAdvancedChecklists
        editable: editable
      })
    )

    @renderAssignee()
    @renderDue()
    @renderName()
    @renderState()
    @recallDrafts()

    trackNameRender(@model.get('name'), @model.getBoard())

    @

  getTextInput: ->
    @$('.js-checkitem-input')

  getMentionTarget: ->
    @$('.js-open-mention-selector')[0]

  getEmojiTarget: ->
    @$('.js-open-emoji-selector')[0]

  renderName: (e) ->
    name = @model.get('name')

    @$('.js-checkitem-row').data('unmarkeddown', name)

    nameHtml = TFM.checkItems.format(name, { textData: @model.get('nameData') }).output
    $name = @$('.js-checkitem-name')
    $name.empty().append(nameHtml)

    friendlyLinks $name[0], @model.getBoard()
    return

  renderAssignee: ->
    if !hasAdvancedChecklists(@model.getBoard())
      return

    member = getAssignee(@model.get('name'), @model.getBoard())

    @$('.js-checklist-item-assignee').html(assigneeTemplate({
      member: member?.toJSON()
    }))
    .toggleClass('no-assignee', !member?)
    return

  renderDue: ->
    if !hasAdvancedChecklists(@model.getBoard())
      return

    due = getDueDate(@model.get('name'), @model.getBoard())

    dueText = due && Dates.toDateString(due)

    className =
      if due
        complete = @model.get('state') == 'complete'
        DueDateHelpers.classForDueDate(moment(due).add(1, 'days').toDate(), complete)
      else
        ""

    @$('.js-checklist-item-due').html(dueTemplate(dueText, className))
    .toggleClass('no-due', !due)

    return

  renderState: (e) ->
    data = @model.toJSON()
    data.checked = (data.state == 'complete')
    @$el.toggleClass('checklist-item-state-complete', data.checked)
    return

  toggleState: (e) ->
    return if !@model.editable()

    isComplete = @model.get('state') == 'complete'

    newState = if isComplete then 'incomplete' else 'complete'

    if newState == 'complete'
      @$el.addClass('checklist-item-fade-out')

      @setTimeout =>
        @model.update('state', newState)
        @$el.removeClass('checklist-item-fade-out')
      , 200

    else
      @$el.removeClass('checklist-item-fade-out')
      @model.update('state', newState)

    track("Checklist", "Toggle Checklist Item State", newState)

    return

  moveCheckItem: (e, ui, checklist, toDifferentChecklist) ->
    if !toDifferentChecklist && @model.getChecklist() != checklist
      # We've already handled this as a move to a different checklist
      return

    checkItems = ui.item.parent().children()
    index = checkItems.index(ui.item)
    pos = checklist.calcPos(index, @model)

    if toDifferentChecklist
      @model.update { pos, idChecklist: checklist.id }
      @model.collection.remove(@model)
      checklist.checkItemList.add(@model)
    else
      @model.update('pos', pos)

    checklist.checkItemList.sort({ silent: true })

    track("Checklist", "Reorder Checklist Item")

  commitEdits: (e) ->
    PopOver.hide()
    if @$('.js-checkitem-input').val().length == 0
      @model.destroy()
    else
      prevName = @model.get('name')
      super
      trackNameChange(prevName, @model.get('name'), 'by clicking save button in edit checkitem view', @model.getBoard())

  _setName: (newName, trackingMethod) ->
    prevName = @model.get('name')
    newName = newName.trim()

    # Update the textarea value as well, so that we don't save a draft
    # of the old value.
    textarea = @$('.field')

    if newName.length == 0
      @model.destroy()
      trackUe('card detail', 'removes', 'checklist item', '', '', trackingMethod)
    else
      if textarea?.val() == prevName
       textarea?.val(newName)

      @model.update('name', newName)
      trackNameChange(prevName, newName, trackingMethod, @model.getBoard())


  openMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: e.target
      view: CheckItemMenuView
      options: { @model, @modelCache }
      keepEdits: true
